<template>
  <hp6-text-select 
    :label-text="label" 
    :id="elementId" 
    :label-size-selection="labelSize" 
    :selected-index="selectedIndex"
    >
      <select v-model="model" @change="onChanged">
        <option v-for="item in items" :key="item.value" :value="item.value">{{ item.label }}</option>
      </select>
  </hp6-text-select>
</template>

<script setup>

/**
 * This component is a Vue wrapper component for the hp-text-select component to make it more usable and
 * available via the v-model directive.
 *
 * Props:
 * value - This props is not supplied directly.  It allows the component to participate in two-way binding via v-model.  Value is the input
 * of the v-model.
 *
 * elementId - The elementId that identifies the component.
 * label - The label of the select component.
 * labelSize - Size of the label - xl, lg, md, sm, xs etc.
 * items - An array of JSON objects in the following format.
 *
 * [
 *  { label: "Some label", value: "theValue"}
 *  { label: "Some label2", value: "theValue2"}
 * ]
 *
 * Events:  The component will support two-way binding via v-model, but also generates a
 * 'changed' event when the value of the select changes.
 */

const props = defineProps({
    elementId: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    labelSize: {
      type: String,
      required: false,
      default: 'xs',
    },
    items: {
      type: Array,
      required: true,
    },
  })

  const model = defineModel()
  const emit = defineEmits(['changed'])

  const onChanged = (event) => {
    emit('changed', event.target.value)
  }

  // Keep the text-select's visual selection in sync with the bound v-model value.
  // Loose comparison since values restored from URL query params arrive as strings.
  const selectedIndex = computed(() => {
    const currentIndex = props.items?.findIndex((item) => item.value == model.value)
    return currentIndex === undefined || currentIndex === -1 ? 0 : currentIndex
  })


</script>
